import { Link } from "react-router-dom";

const LINKS = [
  ["Friends", "/#friends", "nav-friends-link"],
  ["Watch", "/#watch", "nav-watch-link"],
  ["Color!", "/#color", "nav-color-link"],
];

export const Header = () => {
  return (
    <header data-testid="nav-header" className="sticky top-0 z-40 border-b border-sky-100 bg-white/70 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-8">
        <Link to="/" data-testid="nav-logo-link" className="logo-text shrink-0 text-xl leading-none sm:text-3xl" style={{ textShadow: "0 3px 0 #0b4fa3, 2px 0 0 #0b4fa3, -2px 0 0 #0b4fa3, 0 -2px 0 #0b4fa3, 0 5px 0 #0b4fa3" }}>
          Handy <span className="text-[#ffe14d]">&</span> Friends
        </Link>
        <nav className="no-scrollbar flex items-center gap-1 overflow-x-auto sm:gap-2">
          {LINKS.map(([label, href, id]) => (
            <Link
              key={id}
              to={href}
              data-testid={id}
              className="whitespace-nowrap rounded-full px-3 py-2 font-display text-sm font-semibold text-[#0b4fa3] transition-colors hover:bg-sky-100 sm:px-4 sm:text-base"
            >
              {label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
};
